<div class="spinner-container">
  <mat-spinner
    backdropEnabled="true"
    positionGloballyCenter="true"
  ></mat-spinner>
</div>
